import React from 'react'
import { usePageContext } from '../../pages/context'
import Button from '../../shared/Button';
import { addToCart } from "../../../store/order";
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store';

export default function AddToCart({ label }: { label: string }) {
    const { productDetailProduct: selectedProduct } = usePageContext();
    const dispatch = useDispatch<AppDispatch>();
    const orderId = useSelector((state: RootState) => state.order.order?.id);
    const [adding, setAdding] = React.useState(false);

    if (!selectedProduct) { return <></>; }
    const handleAddToCart = async () => {
        setAdding(true);
        await dispatch(addToCart({ orderId, skuId: selectedProduct.id, quantity: 1 }));
        setAdding(false);
    };

    return <Button
        className=""
        loader={adding}
        disabled={adding}
        onClick={handleAddToCart}
    >
        {label || "Add to Cart"}
    </Button>
}
